import React, { useState } from "react";
import { Grid } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

function LoginPage() {
  const [adminID, setAdminID] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const url = "https://devuse-fullstack.vercel.app/admin/login";
      const response = await axios.post(url, {
        adminID,
        adminPassword,
      });

      const token = response.data.token;
      localStorage.setItem("jwtToken", token);
      navigate("/dashboard");
    } catch (error) {
      setLoginError("Invalid credentials. Please try again.");
      console.error(error);
    }
  };

  return (
    <div className="l-container">
      <Grid container justifyContent={"center"}>
        <Grid item lg={4}>
          <div className="l-input-container">
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                value={adminID}
                onChange={(e) => setAdminID(e.target.value)}
                placeholder="Enter ID Here"
              />
              <input
                type="password"
                value={adminPassword}
                onChange={(e) => setAdminPassword(e.target.value)}
                placeholder="Enter Passcode Here"
              />
              {loginError && <p className="error-message">{loginError}</p>}

              <button type="submit">
                <p></p>
                <svg
                  stroke-width="4"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  fill="none"
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                    stroke-linejoin="round"
                    stroke-linecap="round"
                  ></path>
                </svg>
              </button>
            </form>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default LoginPage;
